import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { TranslateModule } from '@ngx-translate/core';
import { ChartComponent, LoadingStateComponent } from '@sb/ui';

import { GraphMode, GraphSize, TurnoverGraphDataType } from '../../enums';
import { ChartTurnoverResponse } from '../../models';
import { ChartHelperService, ChartLineChart } from '../../services/chart-helper.service';

@Component({
  selector: 'app-turnover-graph',
  templateUrl: './turnover-graph.component.html',
  standalone: true,
  imports: [ChartComponent, NgClass, TranslateModule, LoadingStateComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TurnoverGraphComponent {
  private readonly chartHelper = inject(ChartHelperService);

  public readonly graphData = input.required<ChartTurnoverResponse>();
  public readonly isLoading = input<boolean>(false);
  public readonly mode = input<GraphMode>('graph');
  public readonly size = input<GraphSize>('medium');
  public readonly graphType = input.required<TurnoverGraphDataType>();

  public height = computed(() => this.chartHelper.getHeight(this.size()));
  public title = computed(() => this.titleMapByGraphType[this.graphType()]);

  public chart = computed(() => this.getChart());

  private getChart(): ChartLineChart {
    const graphType = this.graphType();
    const graphData = this.graphData();
    if (!graphType || !graphData) {
      return null;
    }
    return this.chartHelper.convertResponseToLineChart(graphData, 'turnover', graphType);
  }

  private readonly titleMapByGraphType: Record<TurnoverGraphDataType, string> = {
    [TurnoverGraphDataType.SALARY_COST_PERCENTAGE]: _('Salary cost percentage'),
    [TurnoverGraphDataType.COC_PERCENTAGE]: _('Salary cost percentage including CoC'),
    [TurnoverGraphDataType.SICK_LEAVE_PERCENTAGE]: _('Absence percentage'),
    [TurnoverGraphDataType.TURNOVER_PER_HOUR]: _('Turnover per hour'),
    [TurnoverGraphDataType.SALARY_PER_HOUR]: _('Salary per hour'),
  };
}
